import { render, staticRenderFns } from "./TarikUnit.vue?vue&type=template&id=2581f98a&scoped=true&"
import script from "./TarikUnit.vue?vue&type=script&lang=ts&"
export * from "./TarikUnit.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2581f98a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/agent/workspace/SPP/deployment/frontend-erp-spp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2581f98a')) {
      api.createRecord('2581f98a', component.options)
    } else {
      api.reload('2581f98a', component.options)
    }
    module.hot.accept("./TarikUnit.vue?vue&type=template&id=2581f98a&scoped=true&", function () {
      api.rerender('2581f98a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/sales/berita-acara/ba-tarik-unit/TarikUnit.vue"
export default component.exports